import { useEffect, useState } from 'react'
import { LocaleEnum } from '@systemeio/ui-frontend'
import { useRouter } from 'next/router'
import useUser from 'shared/hooks/use-user'
import { buildDashboardUrl } from 'modules/white-label/utils/dashboard-url'

export const useGetLoginUrl = () => {
  const { locale, defaultLocale, asPath, isReady } = useRouter()
  const { user } = useUser()
  const currentLocale = user?.dashboardLocale || locale || defaultLocale || LocaleEnum.ENGLISH
  const [loginUrl, setLoginUrl] = useState(`/${currentLocale}/login`)

  useEffect(() => {
    if (!isReady) return
    const origin = window.location.origin
    const fullCurrentUrl = `${origin}${asPath}`
    const encodedRedirect = encodeURIComponent(fullCurrentUrl)
    const newUrl = `/${currentLocale}/login?redirectUrl=${encodedRedirect}`
    setLoginUrl(prev => (prev !== newUrl ? newUrl : prev))
  }, [asPath, currentLocale, isReady])

  return loginUrl
}

export const getContactUrl = (contactId: string) =>
  buildDashboardUrl(`/dashboard/contacts/${contactId}`)
